export const translateSessionName = (name, t, fallback = '') => {
  if (!name) return fallback;
  const key = `sessionNames.${name}`;
  const translated = t(key);
  return translated === key ? name : translated;
};

export const translateSessionMode = (mode, t) => {
  if (!mode) return '';
  const key = `sessionModes.${mode}`;
  const translated = t(key);
  return translated === key ? mode : translated;
};

export const translateSessionStatus = (status, t) => {
  if (!status) return '';
  const key = `sessionStatuses.${status}`;
  const translated = t(key);
  return translated === key ? status : translated;
};
